import React from "react";
import * as R from "ramda";
import { css } from "glamor";

const styles = {
    linkList: css({
        listStyle: "none",
        paddingLeft: 0,
    }),
    linkItem: css({}),
};

class CollapsibleLinkViewer extends React.Component {
    constructor(props) {
        super(props);
        R.forEachObjIndexed((style, styleKey) => {
            styles[styleKey] = css(styles[styleKey], style);
        }, props.styles);
        this.state = { collapsed: true };
    }

    expand = () => {
        this.setState({ collapsed: false });
    };

    collapse = () => {
        this.setState({ collapsed: true });
    };

    render() {
        const data = this.props.data.map(link => (
            <li key={link} className={styles.linkItem}>
                <a href={link} rel="noopener noreferrer" target="_blank">
                    {link}
                </a>
            </li>
        ));

        let content = null;
        let link = null;

        if (this.state.collapsed) {
            content = (
                <ul className={styles.linkList}>
                    {data.slice(0, this.props.maxLength)}
                </ul>
            );
            if (data.length > this.props.maxLength) {
                link = (
                    <div>
                        {this.props.disableExpand ? (
                            "..."
                        ) : (
                            <a role="button" onClick={this.expand}>
                                Click to see more
                            </a>
                        )}
                    </div>
                );
            }
        } else {
            content = <ul className={styles.linkList}> {data} </ul>;
            link = (
                <div>
                    <a role="button" onClick={this.collapse}>
                        Click to see less
                    </a>
                </div>
            );
        }

        return (
            <div>
                {content}
                {link}
            </div>
        );
    }
}

export default CollapsibleLinkViewer;
